<template>
  <div class="monitoring-wrap">
    <template-search-read :readApi="readApi"
                          :reload="reload"
                          @button="button"
                          @searchFilter="getSearchFilter">
    </template-search-read>
  </div>
</template>

<script>
import { EventBus } from '@/utils/event-bus'
import { alertError } from '@/utils/tools'

import { getBaPaymentErrorMonitoring, deleteBaPaymentDateError, deleteBaPaymentLastStatusError } from '@/api/monitoring'

import TemplateSearchRead from '@/components/_template/SearchRead'

export default {
  name: 'MonitoringBaPaymentError',
  components: {
    TemplateSearchRead
  },
  methods: {
    getSearchFilter (value) {
      this.searchFilter = value
    },
    button (value, data) {
      if (value === 'deleteDateError') {
        if (confirm('완료 처리를 하시겠습니까?')) {
          EventBus.$emit('onLoading', true)
          deleteBaPaymentDateError({
            id: data.id
          }).catch(error => {
            alertError('삭제에 실패했습니다.', error)
          }).finally(() => {
            EventBus.$emit('onLoading', false)
            this.reload++
          })
        }
      } else if (value === 'deleteLastStatusError') {
        if (confirm('완료 처리를 하시겠습니까?')) {
          EventBus.$emit('onLoading', true)
          deleteBaPaymentLastStatusError({
            id: data.id
          }).catch(error => {
            alertError('삭제에 실패했습니다.', error)
          }).finally(() => {
            EventBus.$emit('onLoading', false)
            this.reload++
          })
        }
      }
    }
  },
  data () {
    return {
      reload: 0,
      readApi: getBaPaymentErrorMonitoring,
      searchFilter: {}
    }
  }
}
</script>

<style lang="scss" scoped>
.monitoring-wrap {
}
</style>
